export const SET_TAPPS = 'SET_TAPPS';
export const UPDATE_TAPP = 'UPDATE_TAPP';
